import { takeEvery, put, all } from 'redux-saga/effects';

import apiFetcher from '../../tools/api-fetcher';
import handleError from '../../tools/error-helper';

import * as types from '../../actions/candidate/candidate-profile-revision/comparison/types';
import * as actions from '../../actions/candidate/candidate-profile-revision/comparison';

function* getCandidateProfileRevisionComparedData({ schoolId, vacancyId, applicationId, candidateProfileRevisionBatch }) {
  yield put(actions.setCandidateProfileRevisionComparedDataLoading(true));

  try {
    const { data: applicationSummary } = yield apiFetcher.auth().get(`/schools/${schoolId}/vacancies/${vacancyId}/applications/${applicationId}/summary`);

    const { data } = yield apiFetcher.auth().post(`schools/${schoolId}/candidates/${applicationSummary.candidateId}/profile/revisions/comparisons`, {
        candidateProfileRevisionNumbers: candidateProfileRevisionBatch
    });
    
    yield put(actions.setCandidateProfileRevisionComparedData(data));
  } catch (exception) {
    handleError(exception);
  }

  yield put(actions.setCandidateProfileRevisionComparedDataLoading(false));
}

export default function* candidateProfileRevisionsComparisonSaga() {
  yield all([
    takeEvery(types.CANDIDATE_PROFILE_REVISION_COMPARISON_GET_COMPARED_DATA, getCandidateProfileRevisionComparedData)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/candidate/candidate-profile-revisions-comparison.js